import Drawer from "./General/Drawer"
import Input from "./General/Input";
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAPIList } from "../store/CoreSlice";
import Link from "next/link";
import styled from "styled-components";
import homeStyles from "../styles/Home/Home.module.css";
import { MixpanelTracking } from "../MixPanel";
import useDidMountEffect from "../hooks/useDidMountEffect";
import { useRouter } from "next/router";

const StyledSearchDiv = styled.div`
	background-color : #EC6303;
	color : white;
	padding : 10px;
	border-radius : 3px;

	@media all and (min-width : 1024px) {
		padding : 10px;
	}
`

function ProductSearchDrawer(props: any) {
    const dispatch : any = useDispatch();
	const { apiList } = useSelector((state: any) => state.core);
    const [showSearch, setShowSearch] : any = useState(false);	
	const [searchText, setSearchText] : any = useState('');
	const inputRef = useRef(null);
    const mixPanelData = useRef({});
    const router = useRouter()

    useEffect(() => {
        setSearchText('');
    }, [router.asPath]);
    
    useDidMountEffect(() => {
        let count = 0;
        apiList.list.forEach((product : any) => {
            if(product.deals_count)
                count += 1;
        })

        mixPanelData.current = {
            ...mixPanelData.current,
            searchResultCount : apiList.list.length,
            searchResultWithDealsCount : count,
            searchResultTerms : apiList.list
        }

        MixpanelTracking.getInstance().searched(mixPanelData.current);
    }, [searchText])

    const handleSearch = (event : any) => {
		setShowSearch(true);
		setSearchText(event.target.value)
		const params = {
			page : 1,
			page_size : 5,
			search : event.target.value
		}
		dispatch(getAPIList(params));
        mixPanelData.current = {...mixPanelData.current, searchTerm : event.target.value}
	}

    const handleSearchBlur = () => {
		setTimeout(() => {
			setShowSearch(false)
		}, 300);
	}

    return (
        <Drawer show={false} fullScreen>
            <Input
                search
                name="ProductSearch"
                onInput={handleSearch}
                onBlur={handleSearchBlur}
                value={searchText}
                prefix={
                    <StyledSearchDiv className={`m-[9px] ml-[5px] ${props.prefixStyles}`}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`${props.searchIconHeight}`}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
                        </svg>
                    </StyledSearchDiv>
                }
                // suffix = {
                // 	<StyledMic className="cursor-pointer">
                // 		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                // 			<path strokeLinecap="round" strokeLinejoin="round" d="M12 18.75a6 6 0 006-6v-1.5m-6 7.5a6 6 0 01-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 01-3-3V4.5a3 3 0 116 0v8.25a3 3 0 01-3 3z" />
                // 		</svg>
                // 	</StyledMic>
                // }
                placeholder='Search Product / CAS number'
                outerProperties={`
                    rounded 
                    ${props.shadow && 'drop-shadow-md'}
                    ${props.styles}
                `}
            />
    
            <div className="mt-6 px-5">
                {
                    apiList.list.map((product : any) => (
                        <Link key={product.id} href={`/products/${product.slug}`} className="block mb-2 border-b py-1 cursor-pointer">
                            <p> {product.name} </p>
                            <small className="font-light"> {product.product_type} </small>
                        </Link>
                    ))
                }
            </div>
        </Drawer>
    )
}

ProductSearchDrawer.defaultProps = {
    shadow: true,
    styles: '',
    searchIconHeight: 'w-4 h-4 lg:w-8 lg:h-8',
    prefixStyles: ''
}

export default ProductSearchDrawer